import React from "react";

/**
 * DuckyAvatar — renders the Credit Quack mascot head inside a soft circle.
 * Drop-in replacement for the 🦆 emoji everywhere in the app.
 *
 * Props:
 *   size?: number  — pixel size of the circle (default 40)
 *   ring?: boolean — subtle ring for polish (default true)
 *   className?: string — extra tailwind classes for the wrapper
 *   bare?: boolean — if true, skip the circle wrapper (image only)
 */
export const DUCKY_LOGO_URL =
  "https://customer-assets-jt897jd0.emergentagent.net/job_quack-dashboard-pro/artifacts/xfg8uhl1_ChatGPT%20Image%202%20%E0%B8%81.%E0%B8%A2.%202569%2016_25_03.png";

export default function DuckyAvatar({ size = 40, ring = true, className = "", bare = false, alt = "Ducky" }) {
  if (bare) {
    return (
      <img
        src={DUCKY_LOGO_URL}
        alt={alt}
        width={size}
        height={size}
        style={{ width: size, height: size }}
        className={`object-contain select-none ${className}`}
        draggable={false}
      />
    );
  }
  return (
    <span
      className={`inline-flex items-center justify-center rounded-full bg-white overflow-hidden shrink-0 ${ring ? "ring-1 ring-amber-200 shadow-sm" : ""} ${className}`}
      style={{ width: size, height: size }}
      aria-label={alt}
    >
      <img
        src={DUCKY_LOGO_URL}
        alt={alt}
        width={size}
        height={size}
        style={{ width: size * 0.92, height: size * 0.92 }}
        className="object-contain select-none"
        draggable={false}
      />
    </span>
  );
}
